import React from 'react'
import { graphql } from 'gatsby'
import { PlainImage } from '../../components/image'
import {
  Container,
  Intro,
  Subtitle,
  Text,
  Title,
  Section,
  Background,
} from '../../components/page'

import * as styles from './why-nftfi.module.scss'

export type WhyNftfiProps = Queries.WhyNftfiFragment

export const WhyNftfi = ({ title, text, items }: WhyNftfiProps) => {
  return (
    <Section className={styles.section} variant="dark">
      <Container className={styles.container}>
        <div className={styles.intro}>
          <Title color="light">{title}</Title>
          <Intro color="light">{text?.text}</Intro>
        </div>
        <div className={styles.items}>
          {items?.map((item) => (
            <div key={item?.id} className={styles.item}>
              <PlainImage className={styles.image} image={item?.image} />
              <Subtitle color="light">{item?.title}</Subtitle>
              <Text color="lighter" nomargin>
                {item?.text?.text}
              </Text>
            </div>
          ))}
        </div>
      </Container>
      <Background variant="whynftfi" />
    </Section>
  )
}

export const WhyNftfiFragments = graphql`
  fragment WhyNftfiItem on ContentfulWhyNftfiItem {
    __typename
    id
    title
    text {
      text
    }
    image {
      ...SvgImage
    }
  }
  fragment WhyNftfi on ContentfulWhyNftfi {
    __typename
    id
    title
    text {
      text
    }
    items {
      ...WhyNftfiItem
    }
  }
`
